export default function ProfileSkeleton() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container-custom py-12">
        {/* Header Skeleton */}
        <div className="card mb-8 animate-pulse">
          <div className="flex flex-col md:flex-row md:items-start gap-6">
            {/* Profile Photo */}
            <div className="w-32 h-32 rounded-full bg-gray-300" />

            {/* Main Info */}
            <div className="flex-grow space-y-3">
              <div className="h-10 bg-gray-300 rounded w-1/2" />
              <div className="h-6 bg-gray-300 rounded w-1/3" />
              <div className="h-4 bg-gray-300 rounded w-1/4" />
              <div className="h-20 bg-gray-300 rounded w-full" />
            </div>
          </div>
        </div>

        {/* Content Grid Skeleton */}
        <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Sidebar Skeleton */}
          <div className="lg:col-span-1 space-y-6">
            <div className="card animate-pulse">
              <div className="h-6 bg-gray-300 rounded w-1/2 mb-4" />
              <div className="space-y-3">
                <div className="h-4 bg-gray-300 rounded" />
                <div className="h-4 bg-gray-300 rounded" />
              </div>
            </div>

            <div className="card animate-pulse">
              <div className="h-6 bg-gray-300 rounded w-1/2 mb-4" />
              <div className="space-y-3">
                <div className="h-4 bg-gray-300 rounded" />
                <div className="h-4 bg-gray-300 rounded" />
                <div className="h-4 bg-gray-300 rounded" />
              </div>
            </div>
          </div>

          {/* Main Content Skeleton */}
          <div className="lg:col-span-2 space-y-8">
            <div className="card animate-pulse">
              <div className="h-8 bg-gray-300 rounded w-1/3 mb-6" />
              <div className="space-y-6">
                <div className="space-y-3">
                  <div className="h-6 bg-gray-300 rounded w-2/3" />
                  <div className="h-4 bg-gray-300 rounded w-1/2" />
                  <div className="h-20 bg-gray-300 rounded" />
                </div>
                <div className="space-y-3">
                  <div className="h-6 bg-gray-300 rounded w-2/3" />
                  <div className="h-4 bg-gray-300 rounded w-1/2" />
                  <div className="h-20 bg-gray-300 rounded" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
